import type { SearchFilters } from "../../components/FilterBar/filterChipDefs";

// Boolean filter keys that serialize as "true"/"false"
export const BOOLEAN_KEYS = new Set([
  "agentNameExactMatch", "legalHold", "hasMedia", "hasTranscription", "hasRetention",
]);

// Numeric filter keys
export const NUMERIC_KEYS = new Set(["minDuration", "maxDuration"]);

export function filtersToParams(filters: SearchFilters): URLSearchParams {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(filters)) {
    if (value == null || value === "" || value === undefined) continue;
    if (key === "tags" && Array.isArray(value)) {
      for (const tag of value) params.append("tags", tag);
    } else if (key === "siteIds" && Array.isArray(value)) {
      for (const id of value) params.append("siteIds", id);
    } else if (typeof value === "boolean") {
      params.set(key, String(value));
    } else {
      params.set(key, String(value));
    }
  }
  return params;
}

export function paramsToFilters(params: URLSearchParams): SearchFilters {
  const filters: SearchFilters = {};
  const tags: string[] = [];
  const siteIds: string[] = [];
  let legacySiteId: string | undefined;

  for (const [key, value] of params.entries()) {
    if (key === "tags") { tags.push(value); continue; }
    if (key === "siteIds") { siteIds.push(value); continue; }
    if (key === "siteId") { legacySiteId = value; continue; }
    if (BOOLEAN_KEYS.has(key)) {
      (filters as any)[key] = value === "true";
    } else if (NUMERIC_KEYS.has(key)) {
      const num = Number(value);
      if (!Number.isNaN(num)) (filters as any)[key] = num;
    } else {
      (filters as any)[key] = value;
    }
  }

  if (tags.length > 0) filters.tags = tags;
  if (siteIds.length > 0) filters.siteIds = siteIds;
  else if (legacySiteId) filters.siteIds = [legacySiteId];

  // If only fromRetention / toRetention is present without an explicit hasRetention,
  // coerce hasRetention = true so the chip displays consistently.
  if (filters.hasRetention === undefined && (filters.fromRetention || filters.toRetention)) {
    filters.hasRetention = true;
  }

  return filters;
}
